import styled from 'styled-components';

//info-title default
export const ArenaTitleDefaultBox = styled.div`
    font-size: 1.5rem;
    color: ${props => props.theme.colors.bodyText};
    font-weight: 600;
    padding-top: 3rem;
    padding-left: 0.5rem;
`;